import {AccordionAnkerLinks} from "./Components/accordionAnkerLinks";

(function ($) {
	new AccordionAnkerLinks();
})(jQuery);
